import { render, staticRenderFns } from "./Ecology.vue?vue&type=template&id=2144c75a&scoped=true"
import script from "./Ecology.vue?vue&type=script&lang=js"
export * from "./Ecology.vue?vue&type=script&lang=js"
import style0 from "./Ecology.vue?vue&type=style&index=0&id=2144c75a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2144c75a",
  null
  
)

export default component.exports